<template>
  <div>
    <el-form :inline="true">
      <el-form-item>
        <el-input
            v-model="search"
            placeholder="输入试卷名称搜索"
            clearable
            @change="getPaperList">
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="getPaperList" class="el-icon-search" type="primary"></el-button>
      </el-form-item>

      <el-form-item>
        <el-popconfirm title="确定批量删除?" @confirm="delHandle(null)">
          <el-button type="danger" slot="reference" :disabled="delBtlStatu" v-if="hasPermission()">删除选中</el-button>
        </el-popconfirm>
      </el-form-item>
      <el-form-item>
        <template>
          <el-select v-model="subject" clearable placeholder="按学科分类" @change="getPaperList">
            <el-option
                v-for="item in subject_list"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </template>
      </el-form-item>
    </el-form>

    <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        border
        stripe
        @selection-change="handleSelectionChange">
      <el-table-column
          type="selection"
          width="40">
      </el-table-column>
      <el-table-column
          prop="id"
          label="id"
          width="70">
      </el-table-column>
      <el-table-column
          prop="name"
          label="试卷名称"
          width="500">
        <template slot-scope="scope">
          <span>{{ (scope.row.name).slice(0, 34) }}...</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="subject_name"
          label="学科"
          width="120">
      </el-table-column>
      <el-table-column
          prop="paper_score"
          label="试卷总分"
          width="100">
      </el-table-column>
      <el-table-column
          prop="time"
          label="创编时间"
          width="180">
      </el-table-column>

      <el-table-column
          prop="icon"
          label="操作">
        <template slot-scope="scope">
          <el-button @click="editHandle(scope.row.id)" size="mini">编辑</el-button>
          <el-button @click="showPaper(scope.row.id)" size="mini">预览
          </el-button>
          <span>&nbsp;&nbsp;</span>
          <template>
            <el-popconfirm title="确定删除?" @confirm="delHandle(scope.row.id)">
              <el-button type="danger" slot="reference" v-if="hasPermission()" size="mini">删除</el-button>
            </el-popconfirm>
          </template>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100]"
        :current-page="current"
        :page-size="size"
        :total="total">
    </el-pagination>
    <div class="app-footer">© 海之林科技 在线考试系统</div>
  </div>
</template>

<script>
import {normalizePageData} from '@/utils/pageData'

export default {
  name: "PaperList",
  components: {},
  data() {
    return {
      subject: null,
      search: '',
      delBtlStatu: true,
      total: 0,
      size: 10,
      current: 1,
      subject_list: [],
      tableData: [],
      multipleSelection: [],
    }
  },
  created() {
    this.getPaperList()
  },
  methods: {
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.delBtlStatu = val.length === 0
    },
    handleSizeChange(val) {
      this.size = val
      this.getPaperList()
    },
    handleCurrentChange(val) {
      this.current = val
      this.getPaperList()
    },
    resetForm() {
      this.editForm = {}
    },
    handleClose() {
      this.resetForm()
    },
    getPaperList() {
      this.$http({
        url: this.$settings.BASE_URL + '/paper/paper_List/',
        method: 'get',
        params: {
          page: this.current,
          size: this.size,
          search: this.search,
          subject: this.subject,
        },
      }).then(res => {
        if (res.data.code === 20000) {
          const pageData = normalizePageData(res.data)
          this.tableData = pageData.rows
          this.total = pageData.count
        } else {
          this.$message({
            type: 'warning',
            message: res.data.msg,
            duration: 3000,
          })
        }
      })
      this.$http({
        url: this.$settings.BASE_URL + '/paper/subject_list/',
        method: 'get',
      }).then(res => {
        this.subject_list = normalizePageData(res.data).rows
      })
    },
    editHandle(id) {
      this.$router.push(`/teacher/EditPaper/?id=${id}`)
    },
    delHandle(id) {
      let ids = []
      if (id) {
        ids.push(id)
      } else {
        this.multipleSelection.forEach(row => {
          ids.push(row.id)
        })
      }
      this.$http({
        url: this.$settings.BASE_URL + '/paper/paper_edit/del_paper/',
        method: 'post',
        data: ids,
      }).then(res => {
        if (res.data.code === 20000) {
          this.$message({
            showClose: true,
            message: res.data.msg,
            type: 'success',
          });
          this.getPaperList()
        } else {
          this.$message({
            type: 'error',
            message: res.data.msg,
            duration: 3000,
          })
        }
      })
    },
    showPaper(id) {
      this.$router.push(`/ReadPaper/?id=${id}`,)
    },
  }
}
</script>

<style scoped>

</style>
